import {
  API_ROOT_URL,
  ASSIGN_PACK_PRODUCT_TO_ORG,
  GET_PACK_PRODUCT_LIST,
  GET_PENDING_PACK_REQUESTS,
  GET_PURCHASED_PACK_INFO,
  GET_STRIPE_ID_AMOUNT,
  PACK_PRODUCT_FEATURES,
  SUBSCRIPTION_PURCHASED_PACKS,
} from '../../config/constant/apiConstant';
import {
  SUBSCRIPTION_ADD_ON_PRODUCT,
  SUBSCRIPTION_CARD_DETAILS,
  SUBSCRIPTION_CART_DETAILS,
  SUBSCRIPTION_CLIENT,
  SUBSCRIPTION_FAQS,
  SUBSCRIPTION_LINK_EDITOR,
  SUBSCRIPTION_MAIN_PLANS,
  SUBSCRIPTION_PRODUCT_USED_COUNT,
  apiGet,
  apiPost,
  SUBSCRIPTION_DOWNGRADE_MISSING_FEATURE_LIST,
  SUBSCRIPTION_BUY_ONE_TIME_ADD_ONS,
  SUBSCRIPTION_PRO_RATA_PRICE,
  SUBSCRIPTION_ADD_ON_PRODUCT_USED_COUNT,
  apiPatch,
  apiPut,
  SUBSCRIPTION_PURCHASED_ADD_ONS_LIST,
  SUBSCRIPTION_MULTIPLE_LINK_EDITOR,
  SUBSCRIPTION_FEATURES,
  SUBSCRIPTION_PRODUCT_USAGE_HISTORY,
  SUBSCRIPTION_PRODUCT_LIST_CLIENT,
  SUBSCRIPTION_PRODUCT_VARIANCE_COUNT,
  apiGetOrganizationDetails,
  SUBSCRIPTION_SETUP_INTENT,
  SUBSCRIPTION_CHECK_DOWNGRADE,
  SUBSCRIPTION_LINK_PRODUCT_DATA,
  SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS,
  SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC,
  SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS_PUBLIC,
  SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC,
  SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC,
  VIDEO_PUBLIC_LINK_PRODUCT,
  SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_ORDER,
  SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC,
  SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_ORDER,
  SUBSCRIPTION_ALL_PRODUCT_USED_COUNT,
  CANCEL_INVOICE_URL,
  SUBSCRIPTION_CLIENT_UPLOAD_LIMIT,
  SUBSCRIPTION_MAIN_PLAN_PRO_RATA_PRICE,
  SUBSCRIPTION_CONFIGURATOR_DEDUCT,
  SUBSCRIPTION_CLIENT_V2,
  SUBSCRIPTION_PRO_RATA_PRICE_V2,
  SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2,
  SUBSCRIPTION_LINK_TEXTURE_CHECK_STATUS,
  VIDEO_PUBLIC_LINK_TEXTURE,
  SUBSCRIPTION_PRODUCT_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2,
  SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS_PUBLIC,
  SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS,
  SUBSCRIPTION_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC,
  SUBSCRIPTION_AI_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC,
  SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC_V2,
  VIDEO_PUBLIC_CREATE_LINK_TEXTURE,
  SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS_V2,
  SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC,
  SUBSCRIPTION_THREED_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2,
  SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2,
  SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS,
  SUBSCRIPTION_GET_IMAGINE_CREDIT,
  CREDIT_FORM,
  SUBSCRIPTION_IMAGINE_CREDIT_PRODUCT_COUNT_DEDUCT,
} from '../../helpers/api';
import { fetchAllPages } from '../../helpers/apiHelper';

import api, { handleErrorMessageFromAPIFailer } from '../../helpers/axiosHelper';
import { objectToFormData, objectToSearchParams, wait } from '../../helpers/jsHelper';
import { dispatcher } from '../../helpers/projectHelper';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { setFilteredMainSubscriptionsPlan } from '../../hooks/useSubscriptionSetupAPICalls';
import { selectCartAddonsList, subscriptionActions } from '../../redux/slicers/subscriptionSlicer';
import { getAppState } from '../../redux/store';
import { LINKED_PRODUCT_DATA } from '../../screens/subscriptionComponents/subscriptionHelper';

// subscription apis

export const setBillingInfo = () => async (dispatch) => {
  const res = await apiGetOrganizationDetails();
  if (!res) return;
  const {
    billing_first_name,
    billing_last_name,
    billing_address,
    billing_city,
    billing_country,
    billing_email,
    billing_mobile_number,
    billing_pincode,
    billing_state,
    billing_street,
    billing_line1,
    billing_line2,
    billing_line3,
  } = res;
  dispatch(
    subscriptionActions.setBillingInfo({
      billing_name: `${billing_first_name || ''} ${billing_last_name || ''}`?.trim() || '',
      billing_first_name: billing_first_name || '',
      billing_last_name: billing_last_name || '',
      billing_address: billing_address || '',
      billing_city: billing_city || '',
      billing_country: billing_country || '',
      billing_email: billing_email || '',
      billing_mobile_number: billing_mobile_number || '',
      billing_pincode: billing_pincode || '',
      billing_state: billing_state || '',
      billing_street: billing_street || '',
      billing_line1: billing_line1 || '',
      billing_line2: billing_line2 || '',
      billing_line3: billing_line3 || '',
    })
  );
};

export const apiGetFaqs = () => {
  return apiGet(SUBSCRIPTION_FAQS);
};

export const apiMakeEditor = (payload, successMessage = null, errorMessage = null) => {
  const formData = objectToFormData(payload);
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_LINK_EDITOR)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .badRequest400(() => {})
    .send();
};

export const apiMakeMultipleEditor = (formData, successMessage = null, errorMessage = null) => {
  // const formData = objectToFormData(payload);
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_MULTIPLE_LINK_EDITOR)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .badRequest400(() => {})
    .send();
};

export const apiGetClientSubscription = ({
  is_add_on_subscription,
  is_active_main_subscription_plan = undefined,
  organization,
}) => {
  const params = objectToSearchParams({
    is_add_on_subscription,
    is_active_main_subscription_plan,
    organization,
  });
  const URL = `${SUBSCRIPTION_CLIENT}?${params}`;
  return apiGet(URL);
};

export const apiGetClientSubscriptionV2 = ({
  is_add_on_subscription,
  is_active_main_subscription_plan = undefined,
  organization,
}) => {
  const params = objectToSearchParams({
    is_add_on_subscription,
    is_active_main_subscription_plan,
    organization,
  });
  const URL = `${SUBSCRIPTION_CLIENT_V2}?${params}`;
  return apiGet(URL);
};

export const setFailedClientSubscriptionPlansAndAddOns = () => (dispatch) => {
  const URL = `${SUBSCRIPTION_CLIENT}`;
  api()
    .root(API_ROOT_URL)
    .get(URL)
    .success((data) => {
      if (data && data?.results?.length > 0) {
        dispatch(subscriptionActions.setAllPurchasedListPlan(data?.results || []));
        const results = data?.results?.filter(
          (a) =>
            !a?.is_cancelled &&
            a?.is_subscription_incomplete &&
            a?.incomplete_invoice_id &&
            a?.incomplete_payment_intent_id
        ); // .filter(a => a?.plan_details?.length > 0 || a?.plan_name);
        const results2 = data?.results?.filter((a) => !a?.is_cancelled && a?.is_upload_limit_plan);
        dispatch(subscriptionActions.setFailedSubscriptions(results || []));
        dispatch(subscriptionActions.setPurchasedUploadLimitPlan(results2 || []));
      }
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const setFailedClientSubscriptionPlansAndAddOnsV2 = () => (dispatch) => {
  const URL = `${SUBSCRIPTION_CLIENT_V2}`;
  api()
    .root(API_ROOT_URL)
    .get(URL)
    .success((data) => {
      if (data && data?.results?.length > 0) {
        const results = data?.results?.filter(
          (a) =>
            !a?.is_cancelled &&
            a?.is_subscription_incomplete &&
            a?.incomplete_invoice_id &&
            a?.incomplete_payment_intent_id
        ); // .filter(a => a?.plan_details?.length > 0 || a?.plan_name);
        const results2 = data?.results?.filter((a) => !a?.is_cancelled && a?.is_upload_limit_plan);
        dispatch(subscriptionActions.setFailedSubscriptions(results || []));
        dispatch(subscriptionActions.setPurchasedUploadLimitPlan(results2 || []));
      }
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const setClientSubscriptionPlans =
  (is_add_on_subscription = false, is_active_main_subscription_plan = undefined, callback) =>
  (dispatch) => {
    const params = objectToSearchParams({
      is_add_on_subscription,
      is_active_main_subscription_plan,
    });
    const URL = `${SUBSCRIPTION_CLIENT}?${params}`;
    api()
      .root(API_ROOT_URL)
      .get(URL)
      .success(async (data) => {
        let results = data?.results?.filter((a) => a?.plan_details?.length > 0);
        let userPlansData = [];
        if (data && results && results?.length > 0) {
          const activePlan = results.filter((a) => a.is_active_main_subscription_plan);
          const nonActivePlan = results.filter((a) => !a.is_active_main_subscription_plan);
          results = [...activePlan, ...nonActivePlan];

          userPlansData = await Promise.all(
            results.map(async (a) => {
              const addOns = await apiGetSubscriptionProductUsedCount({ subscription_id: a.id });
              if (addOns && addOns.results && addOns.results.length) {
                return {
                  ...a,
                  included_addons: addOns.results,
                };
              }
              return a;
            })
          );
        }
        const mergedArray = [
          ...userPlansData,
          ...data?.results.filter((bItem) => !userPlansData.some((aItem) => aItem.id === bItem.id)),
        ];
        dispatch(subscriptionActions.setUserSelectedPlans(mergedArray));
        await dispatch(setAllProductsUsedCount());
        await wait(1000);
        dispatch(subscriptionActions.setPlanDetailsLoading(false));
        callback?.();
      })
      .error((error) => {
        // TODO: add error handling after decision of the team
        dispatch(subscriptionActions.setPlanDetailsLoading(false));
        callback?.();
      })
      .send();
  };

export const setClientSubscriptionPlansV2 =
  (is_add_on_subscription = false, is_active_main_subscription_plan = undefined) =>
  (dispatch) => {
    const params = objectToSearchParams({
      is_add_on_subscription,
      is_active_main_subscription_plan,
    });
    const URL = `${SUBSCRIPTION_CLIENT_V2}?${params}`;
    api()
      .root(API_ROOT_URL)
      .get(URL)
      .success(async (data) => {
        let results = data?.results?.filter((a) => a?.plan_details?.length > 0);
        let userPlansData = [];
        if (data && results && results?.length > 0) {
          const activePlan = results.filter((a) => a.is_active_main_subscription_plan);
          const nonActivePlan = results.filter((a) => !a.is_active_main_subscription_plan);
          results = [...activePlan, ...nonActivePlan];

          userPlansData = await Promise.all(
            results.map(async (a) => {
              const addOns = await apiGetSubscriptionProductUsedCount({ subscription_id: a.id });
              if (addOns && addOns.results && addOns.results.length) {
                return {
                  ...a,
                  included_addons: addOns.results,
                };
              }
              return a;
            })
          );
        }
        const mergedArray = [
          ...userPlansData,
          ...data?.results.filter((bItem) => !userPlansData.some((aItem) => aItem.id === bItem.id)),
        ];
        dispatch(subscriptionActions.setUserSelectedPlans(mergedArray));
        await dispatch(setAllProductsUsedCount());
        await wait(1000);
        dispatch(subscriptionActions.setPlanDetailsLoading(false));
      })
      .error((error) => {
        // TODO: add error handling after decision of the team
        dispatch(subscriptionActions.setPlanDetailsLoading(false));
      })
      .send();
  };

export const apiToCancelOrRestoreActiveClientSubscription = ({
  id,
  cancel_at_period_end = false,
  successMessage = 'Your plan is successfully cancelled/restored.',
  errorMessage = 'Unable to restore plan. Please try again later.',
}) => {
  const formData = objectToFormData({
    cancel_at_period_end,
  });

  const URL = `${SUBSCRIPTION_CLIENT}${id}`;
  try {
    return api()
      .root(API_ROOT_URL)
      .patch(URL)
      .data(formData)
      .success((res) => {
        if (successMessage) {
          successToast(successMessage);
        }
        return res;
      })
      .error((error) => {
        errorToast(error?.message || errorMessage);
        throw error;
      })
      .badRequest400((error) => {
        errorToast(error?.message || errorMessage);
        throw error;
      })
      .send();
  } catch (error) {
    console.log('apiToCancelOrRestoreActiveClientSubscription error', error);
  }
};

export const apiToCancelOrRestoreActiveClientSubscriptionV2 = ({
  id,
  cancel_at_period_end = false,
  successMessage = 'Your plan is successfully cancelled/restored.',
  errorMessage = 'Unable to restore plan. Please try again later.',
}) => {
  const formData = objectToFormData({
    cancel_at_period_end,
  });

  const URL = `${SUBSCRIPTION_CLIENT_V2}${id}/`;
  try {
    return api()
      .root(API_ROOT_URL)
      .patch(URL)
      .data(formData)
      .success((res) => {
        if (successMessage) {
          successToast(successMessage);
        }
        return res;
      })
      .error((error) => {
        errorToast(error?.message || errorMessage);
        // throw error;
      })
      .badRequest400((error) => {
        errorToast(error?.message || errorMessage);
        // throw error;
      })
      .send();
  } catch (error) {
    console.log('apiToCancelOrRestoreActiveClientSubscription error', error);
  }
};

export const apiGetMainSubscriptionPlans = (perPage) => {
  const params = objectToSearchParams({ is_add_on: false, per_page: perPage || 100 });
  const URL = `${SUBSCRIPTION_MAIN_PLANS}?${params}`;
  return apiGet(URL);
};

export const setMainSubscriptionPlansNoDispatch = (page) => {
  const params = objectToSearchParams({ is_add_on: false, per_page: 100, page: page });
  const URL = `${SUBSCRIPTION_MAIN_PLANS}?${params}`;
  return apiGet(URL);
}

export const setMainSubscriptionPlans = () => (dispatch) => {
  const params = objectToSearchParams({ is_add_on: false, per_page: 100 });
  const URL = `${SUBSCRIPTION_MAIN_PLANS}?${params}`;
  api()
    .root(API_ROOT_URL)
    .get(URL)
    .success((data) => {
      let results = data?.results;
      if (results.length > 0) {
        dispatch(
          subscriptionActions.setPlans(
            results?.filter((_item) => !_item?.is_archived && !_item?.is_feature_product) || []
          )
        );
        setTimeout(setFilteredMainSubscriptionsPlan, 100);
      }
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const apiGetSubscriptionProductUsedCount = ({
  is_manually = undefined,
  is_freemium = undefined,
  subscription_id = undefined,
  perPage = 20,
  page = 1,
}) => {
  const params = objectToSearchParams({
    is_manually,
    is_freemium,
    subscription_id,
    per_page: perPage,
    page,
  });
  const URL = `${SUBSCRIPTION_PRODUCT_USED_COUNT}?${params}`;
  return apiGet(URL);
};

export const apiGetAllProductUsedCount = async () => {
  const result = await fetchAllPages((page) => {
    const URL = `${SUBSCRIPTION_ALL_PRODUCT_USED_COUNT}?page=${page}`;
    return apiGet(URL);
  });

  return result;
};

export const apiGetAddOnsProductUsedCount = ({ perPage = 20, page = 1 }) => {
  const params = objectToSearchParams({ per_page: perPage, page });
  const URL = `${SUBSCRIPTION_ADD_ON_PRODUCT_USED_COUNT}?${params}`;
  return apiGet(URL);
};

export const setFreemiumProductsUsedCount = () => async (dispatch) => {
  const res = await fetchAllPages((page) => {
    return apiGetSubscriptionProductUsedCount({ is_freemium: true, perPage: 20, page });
  });
  if (!res || !res.results) return;
  const results = [...res.results];
  dispatch(subscriptionActions.setFreemiumProductsUsedCount(results));
};

export const setProductsUsedCount = () => async (dispatch) => {
  const res = await fetchAllPages((page) => {
    return apiGetSubscriptionProductUsedCount({ subscription_id: undefined, perPage: 20, page });
  });
  if (!res || !res.results) return;
  const results = [...res.results];
  dispatch(subscriptionActions.setProductsUsedCount(results));
};

export const setCustomProductsUsedCount = () => async (dispatch) => {
  const res = await fetchAllPages((page) => {
    return apiGetSubscriptionProductUsedCount({ is_manually: true, perPage: 20, page });
  });
  if (!res || !res.results) return;
  const results = [...res.results];
  dispatch(subscriptionActions.setAllCustomProductsUsedCount(results));
};

export const getProductsVariationUsedCount = async () => {
  return await apiGet(SUBSCRIPTION_PRODUCT_VARIANCE_COUNT);
};

export const setAllProductsUsedCount = () => async (dispatch) => {
  const response = await apiGetAllProductUsedCount();
  const results = response?.results;

  if (!response || !results || results.length === 0) return;
  // Use reduce to categorize products in one pass
  const { freemium, manual, product } = results?.reduce(
    (acc, a) => {
      if (a.is_freemium) {
        acc.freemium.push(a);
      } else if (a.is_manually) {
        acc.manual.push(a);
      } else {
        acc.product.push(a);
      }
      return acc;
    },
    { freemium: [], manual: [], product: [] }
  );

  dispatch(subscriptionActions.setFreemiumProductsUsedCount(freemium));
  dispatch(subscriptionActions.setAllCustomProductsUsedCount(manual));
  dispatch(subscriptionActions.setProductsUsedCount(product));
};

export const apiMakeSubscriptionPendingPayment = ({ id, organization }) => {
  const payload = {
    organization: organization,
    renew_subscription: true,
  };
  const URL = `${SUBSCRIPTION_CLIENT}${id}`;
  // return apiPut(URL, payload);
  return api()
    .root(API_ROOT_URL)
    .put(URL)
    .data(payload)
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      throw error;
    })
    .send();
};

export const apiMakeSubscriptionPendingPaymentV2 = ({ id, organization }) => {
  const payload = {
    organization: organization,
    renew_subscription: true,
  };
  const URL = `${SUBSCRIPTION_CLIENT_V2}${id}/`;
  // return apiPut(URL, payload);
  return api()
    .root(API_ROOT_URL)
    .put(URL)
    .data(payload)
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // throw error;
    })
    .send();
};

export const GetAllCard = () => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(SUBSCRIPTION_CARD_DETAILS)
    .success((data) => {
      dispatch(subscriptionActions.setPaymentCardList(data));
      dispatch(subscriptionActions.setRefetchCardFlag(false));
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const AddNewCard = (payload, hideToastMessage) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_CARD_DETAILS)
    .data(payload)
    .success((data) => {
      if (!hideToastMessage) {
        successToast('Payment method added');
      }
      dispatch(subscriptionActions.setRefetchCardFlag(true));
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const SetCardDefault = (payload, id) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CARD_DETAILS}${id}`)
    .data(payload)
    .success((data) => {
      successToast('Default payment method changed successfully');
      dispatch(subscriptionActions.setRefetchCardFlag(true));
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const RemoveCard = (id) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .delete(`${SUBSCRIPTION_CARD_DETAILS}${id}`)
    .data()
    .success((data) => {
      successToast('Payment method deleted successfully');
      dispatch(subscriptionActions.setRefetchCardFlag(true));
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const GetAllAddonsProductList =
  (requestParams = {}) =>
  async (dispatch) => {
    const res = await fetchAllPages((page) => {
      let param = { per_page: 20, page, ...requestParams };
      // if (id) {
      //   param.client_subscription_id = id;
      // }
      return GetAllSubscriptionProduct(param);
    });
    if (!res || !res.results) return;
    dispatch(subscriptionActions.setProductAddonsList(res));
  };

export const GetAllSubscriptionProduct = (param) => {
  const params = objectToSearchParams(param);
  const URL = `${SUBSCRIPTION_ADD_ON_PRODUCT}?${params}`;
  return apiGet(URL);
};

export const AddAddonCart = (payload, flag) => {
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_CART_DETAILS)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const GetAllCartProductList =
  (id = null) =>
  async (dispatch) => {
    const res = await fetchAllPages((page) => {
      // let params = {};
      // if(id) {
      //   params.client_subscription_id = id;
      // }
      let params = { per_page: 20, page: page };
      return GetAllCardAddOns(params);
    });
    if (!res || !res.results) return;
    dispatch(subscriptionActions.setCartAddonsList(res));
  };

export const GetAllCardAddOns = (param) => {
  const params = objectToSearchParams(param);
  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_CART_DETAILS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const removeAllItemsFromCart = async () => {
  const { results: cartAddonsList } = selectCartAddonsList(getAppState());

  if (cartAddonsList && cartAddonsList?.length > 0) {
    await Promise.all(
      cartAddonsList.map(async (a) => {
        let payload = {
          quantity: 0,
          subscription_price: a?.subscription_price,
        };
        if (a?.price) {
          payload.price = a?.price;
        }
        await api()
          .root(API_ROOT_URL)
          .post(SUBSCRIPTION_CART_DETAILS)
          .data(payload)
          .success((data) => {
            dispatcher(GetAllCartProductList());
            return data;
          })
          .error((error) => {
            // TODO: add error handling after decision of the team
          })
          .send();
      })
    );
  }
};

export const AddAddonToSubscription = async (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_CLIENT}`)
    .data(JSON.stringify(payload))
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const AddAddonToSubscriptionV2 = async (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_CLIENT_V2}`)
    .data(JSON.stringify(payload))
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // TODO: add error handling after decision of the team
      // throw error;
      handleErrorMessageFromAPIFailer(error);
      return error;
    })
    .send();
};

export const UpdateAddonToSubscription = async (payload, activeSub) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT}${activeSub}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const UpdateAddonToSubscriptionV2 = async (payload, activeSub) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT_V2}${activeSub}/`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // TODO: add error handling after decision of the team
      handleErrorMessageFromAPIFailer(error);
      return error;
    })
    .send();
};

export const UpgradeToNewPlan = async (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_CLIENT}`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      console.log('UpgradeToNewPlan error', error);
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const UpgradeToNewPlanV2 = async (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_CLIENT_V2}`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      console.log('UpgradeToNewPlan error', error);
      // TODO: add error handling after decision of the team
      // throw error;
      handleErrorMessageFromAPIFailer(error);
      return error;
    })
    .send();
};

export const UpgradeToNewPlanPatch = async (payload, id) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT}${id}`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      console.log('UpgradeToNewPlan error', error);
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const UpgradeToNewPlanPatchV2 = async (payload, id) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT_V2}${id}/`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      console.log('UpgradeToNewPlan error', error);
      // TODO: add error handling after decision of the team
      // throw error;
      handleErrorMessageFromAPIFailer(error);
      return error;
    })
    .send();
};

export const DowngradeToNewPlan = (payload, currentPlanId) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT}${currentPlanId}`)
    .data(payload)
    .success((data) => {
      dispatch(subscriptionActions.PlanUpgraded({ downgrade: true }));
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const DowngradeToNewPlanV2 = (payload, currentPlanId) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT_V2}${currentPlanId}/`)
    .data(payload)
    .success((data) => {
      dispatch(subscriptionActions.PlanUpgraded({ downgrade: true }));
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const RemoveAddonsSubscriptionItem = (payload, currentPlanId, restore) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT}${currentPlanId}`)
    .data(payload)
    .success((data) => {
      successToast(`Add-ons Item ${restore ? 'restore' : 'removed'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const RemoveAddonsSubscriptionItemV2 = (payload, currentPlanId, restore) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT_V2}${currentPlanId}/`)
    .data(payload)
    .success((data) => {
      successToast(`Add-ons Item ${restore ? 'restore' : 'removed'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      handleErrorMessageFromAPIFailer(error);
      return error;
    })
    .send();
};

export const DowngradeMissingFeatureList = (currentPlanId) => {
  const URL = `${SUBSCRIPTION_DOWNGRADE_MISSING_FEATURE_LIST}${currentPlanId}`;
  return apiGet(URL);
};

export const BuyOneTimeAddOnPlan = async (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_BUY_ONE_TIME_ADD_ONS}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .badRequest400(() => {})
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const GetProRataPrice = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_PRO_RATA_PRICE}`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const GetProRataPriceV2 = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_PRO_RATA_PRICE_V2}`)
    .data(payload)
    .success((data) => {
      // successToast(`AddOns ${flag ? 'updated' : 'added'} successfully`);
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const GetAllPurchasedOneTimeProductList = async (dispatch) => {
  const res = await fetchAllPages(async (page) => {
    return GetPurchasedOneTimeAddonList({
      is_pack_product: false,
      product__is_one_time: true,
      per_page: 20,
      page,
    });
  });
  if (!res || !res.results) return;
  const finalPlans = res?.results?.reduce((accumulator, current) => {
    let found = false;

    const updatedAccumulator = accumulator.map((item) => {
      const name = item.basemodeltype?.toLowerCase() === 'images' ? item.name : item.basemodeltype;
      if (
        name?.toLowerCase() ===
          (current?.basemodeltype?.toLowerCase() === 'images'
            ? current?.name?.toLowerCase()
            : current?.basemodeltype?.toLowerCase()) &&
        item?.subscription_id === current?.subscription_id
      ) {
        found = true;
        return {
          ...item,
          total_count: item.total_count + current.total_count,
          used_count: item.used_count + current.used_count,
          available_count: item.available_count + current.available_count,
          name,
        };
      }
      return { ...item, name };
    });

    if (!found) {
      updatedAccumulator.push(current);
    }

    return updatedAccumulator;
  }, []);

  dispatch(subscriptionActions.SetAllPurchasedOneTimeAddonsList({ ...res, results: finalPlans }));
  return { ...res, results: finalPlans };
};

export const GetPurchasedOneTimeAddonList = (params) => {
  const param = objectToSearchParams(params);
  const URL = `${SUBSCRIPTION_PRODUCT_USED_COUNT}?${param}`;
  return apiGet(URL);
};

export const GetPurchasedOnAddonsList = () => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_PURCHASED_ADD_ONS_LIST}`)
    .success((data) => {
      dispatch(subscriptionActions.SetAllPurchasedAddonsList(data));
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const GetAllSubscriptionFeatures = (params) => {
  const param = objectToSearchParams(params);
  const URL = `${SUBSCRIPTION_FEATURES}?${param}`;
  return apiGet(URL);
};
export const GetFreemiumSubscriptionFeatures = async (dispatch) => {
  const res = await fetchAllPages(async (page) => {
    return GetAllSubscriptionFeatures({ type: 'FREEMIUM', per_page: 20, page });
  });
  if (!res || !res.results) return;
  dispatch(subscriptionActions.setFreemiumFeatures(res?.results));
  return res;
};

export const GetProductUsageHistory = (params) => {
  const param = objectToSearchParams(params);
  const URL = `${SUBSCRIPTION_PRODUCT_USAGE_HISTORY}?${param}`;
  return apiGet(URL);
};

export const GetProductList = (params) => {
  const param = objectToSearchParams(params);
  const URL = `${SUBSCRIPTION_PRODUCT_LIST_CLIENT}?${param}`;
  return apiGet(URL);
};

export const getSetupIntentData = () => {
  return apiGet(SUBSCRIPTION_SETUP_INTENT);
};

export const getDowngradeInvoiceDetails = (invoiceId) => {
  return apiGet(`${SUBSCRIPTION_CHECK_DOWNGRADE}?invoice_id=${invoiceId}`);
};

export const linkSubscriptionProductData = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_LINK_PRODUCT_DATA}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

/**
 * @param {{
 *  product_type: string;
 *  product_uuid: string;
 *  product_org: number;
 * }} data
 * @returns object
 */
export const apiCheckSubscriptionLinkedProductStatus = (params) => {
  const _params = objectToSearchParams(params);

  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS}?${_params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiCheckSubscriptionLinkedProductStatusV2 = (params) => {
  const _params = objectToSearchParams(params);

  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS_V2}?${_params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiCheckSubscriptionLinkedTextureStatus = (params) => {
  const _params = objectToSearchParams(params);

  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_LINK_TEXTURE_CHECK_STATUS}?${_params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

/**
 * @param {{
 *  isPublicPage: Boolean;
 *  type: string;
 *  product_uuid: string;
 *  product_org: number;
 * }} data
 * @returns object
 */
export const getSubscriptionLinkedProductData = ({
  isPublicPage = false,
  type,
  params = {},
  isV2 = false,
  isTexture = false,
}) => {
  let URL;

  const _params = objectToSearchParams(params);

  if (type === LINKED_PRODUCT_DATA.AI_VIDEO) {
    URL = isPublicPage
      ? isTexture
        ? SUBSCRIPTION_AI_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC
        : isV2
        ? SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC_V2
        : SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC
      : SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS;
  } else if (type === LINKED_PRODUCT_DATA.CONFIGURATOR) {
    URL = isPublicPage
      ? isTexture
        ? SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS_PUBLIC
        : SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS_PUBLIC
      : isTexture
      ? SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS
      : SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS;
  } else if (type === LINKED_PRODUCT_DATA.PRODUCT_VIEWER) {
    URL = isPublicPage
      ? !isV2
        ? SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC
        : isTexture
        ? SUBSCRIPTION_PRODUCT_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2
        : SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2
      : SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS;
  } else if (type === LINKED_PRODUCT_DATA.THREED_VIEWER) {
    // URL = isPublicPage
    //   ? !isV2
    //     ? SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC
    //     : isTexture
    //     ? SUBSCRIPTION_THREED_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2
    //     : SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2
    //   : SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS;

    // we get isV2 true always here as this will used for the product v2 page
    URL = isPublicPage
      ? isTexture
        ? SUBSCRIPTION_THREED_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2
        : SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2
      : SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS;
  } else if (type === LINKED_PRODUCT_DATA.VIDEO) {
    URL = isPublicPage
      ? isTexture
        ? SUBSCRIPTION_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC
        : SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC
      : SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS;
  } else if (type === LINKED_PRODUCT_DATA.PANNING_VIDEO) {
    URL = isPublicPage
      ? SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC
      : SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS;
  }

  if (!URL) return;

  return api()
    .root(API_ROOT_URL)
    .get(`${URL}?${_params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiUpdateProductAIVideoInfo = (id, payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS}${id}/`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiUpdateProductVideoInfo = (id, payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS}${id}/`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiUploadProductPanningVideoInfo = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiUpdateProductPanningVideoInfo = (id, payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS}${id}/`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiDeleteProductPanningVideoInfo = (id) => {
  return api()
    .root(API_ROOT_URL)
    .delete(`${SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS}${id}/`)
    .data()
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const apiUpdateProductVideoOrder = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_ORDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const apiUpdateProductPanningVideoOrder = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_ORDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const getProductVideoPublicData = (params) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${VIDEO_PUBLIC_LINK_PRODUCT}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const getTextureVideoPublicData = (params) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${VIDEO_PUBLIC_LINK_TEXTURE}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const createProductVideoPublicData = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(VIDEO_PUBLIC_LINK_PRODUCT)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const createTextureVideoPublicData = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(VIDEO_PUBLIC_LINK_TEXTURE)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const createTextureVideoPublicDataV2 = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(VIDEO_PUBLIC_CREATE_LINK_TEXTURE)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

// Packs APIs

export const getSubscriptionPurchasedPacks = async () => {
  const url = SUBSCRIPTION_PURCHASED_PACKS;
  const result = await fetchAllPages((page) => {
    const paginatedUrl = `${url}?page=${page}`;
    return apiGet(paginatedUrl);
  });
  return result;
};

// Purchased Pack
export const apiGetPurchasedPacks = async (params = '') => {
  return await fetchAllPages((page) => {
    return api()
      .root(API_ROOT_URL)
      .get(`${GET_PURCHASED_PACK_INFO}?page${page}&per_page=20${params}`)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  });
};

export const apiGetPackProductList = async (params = '') => {
  return await fetchAllPages((page) => {
    return api()
      .root(API_ROOT_URL)
      .get(`${GET_PACK_PRODUCT_LIST}?${params}&page=${page}`)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  });
};

export const getPackProductFeatureList = async ({ packProductId = null } = {}) => {
  let params = '';
  if (packProductId) {
    params = `product=${packProductId}`;
  }

  const results = await fetchAllPages((page) => {
    if (page) {
      params += params !== '' ? '&' : '' + `page=${page}`;
    }
    return api()
      .root(API_ROOT_URL)
      .get(`${PACK_PRODUCT_FEATURES}?${params}`)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  });
  return results;
};

export function AssignPackToOrg(formData) {
  return api()
    .root(API_ROOT_URL)
    .post(ASSIGN_PACK_PRODUCT_TO_ORG)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export const apiGetPendingPackRequests = async () => {
  let params = '';
  const results = await fetchAllPages((page) => {
    if (page) {
      params += params !== '' ? '&' : '' + `page=${page}`;
    }
    return api()
      .root(API_ROOT_URL)
      .get(`${GET_PENDING_PACK_REQUESTS}?${params}`)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  });

  return results;
};

export const apiGetAmountFromStripeId = async (params) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_STRIPE_ID_AMOUNT}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const apiCancelAllInvoices = async ({ payments }) => {
  const responses = [];
  payments.forEach(({ incomplete_invoice_id, subscription_id }) => {
    const payload = JSON.stringify({ invoice_id: incomplete_invoice_id, subscription_id });
    responses.push(
      api()
        .root(API_ROOT_URL)
        .post(CANCEL_INVOICE_URL)
        .data(payload)
        .success((data) => {
          return data;
        })
        .error((error) => {
          return error;
        })
        .send()
    );
  });
  const promises = await Promise.all(responses);
  return promises;
};
export const addNewUploadLimitSubscription = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(SUBSCRIPTION_CLIENT_UPLOAD_LIMIT)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const updateUploadLimitSubscription = (id, payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SUBSCRIPTION_CLIENT_UPLOAD_LIMIT}${id}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
};

export const downgradeToNewUploadSubscription =
  (payload, currentPlanId, timeout = 0) =>
  (dispatch) => {
    return api()
      .root(API_ROOT_URL)
      .patch(`${SUBSCRIPTION_CLIENT_UPLOAD_LIMIT}${currentPlanId}`)
      .data(payload)
      .success((data) => {
        // dispatch?.(subscriptionActions.PlanUpgraded({ downgrade: true }));
        setTimeout(() => {
          successToast(`Plan downgrade Successfully.`);
        }, [timeout]);
        return data;
      })
      .error((error) => {
        // TODO: add error handling after decision of the team
      })
      .send();
  };

export const mainSubscriptionPlanProRata = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_MAIN_PLAN_PRO_RATA_PRICE}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const apiGetProductConfiguratorDeduct = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${SUBSCRIPTION_CONFIGURATOR_DEDUCT}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const getImagineCreditCount = (currentPlanId) => {
  const URL = `${SUBSCRIPTION_GET_IMAGINE_CREDIT}`;
  return apiGet(URL);
};

export const apiGetCreditDetails = async (params = '') => {
  return apiGet(`${CREDIT_FORM}?${params}`,);
};

export const deductImagineCreditProductCount = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${SUBSCRIPTION_IMAGINE_CREDIT_PRODUCT_COUNT_DEDUCT}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};
